import React, { useContext, useEffect, useState } from "react";
import SuccessMessage from "../success-message/hoa-success-message";

import config from "../../hoa-config";
import { GlobalContext } from "../../context/hoa-global-context";
import dashboardServices from "../../services/hoa-dashboard-api-service";

import MailAssignDocument from "../mails/hoa-mail-assign-document";
import PendingSourceTable from "./pending-source-table";
import PendingSourceFiltering from "./pending-source-filtering";
import EmailAssignDocument from "../emails/hoa-email-assign-document";
import AssignPropertyModal from "../mails/hoa-mail-assign-property-modal";

export default function PendingSourceDashboard() {
    const {
        pendingSource,
        updatePendingSource,
        selectedValues,
        updateSelectedValues,
        updateView,
        view: views,
        activeMenu,
        changeActiveMenu,
    } = useContext<any>(GlobalContext);

    const [loading, setLoading] = useState(false);
    const [view, setView] = useState(views !== "view-more-details" ? "list" : "view");

    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState("");
    const [previousSelectedValues, setPreviousSelectedValues] = useState(
        JSON.parse(JSON.stringify(selectedValues))
    );
    const [modalOpen, toggleModalOpen] = useState(false);
    const [currentAssignedProperty, setCurrentAssignedProperty] = useState(null);
    const [assignedPropertyList, setAssignedPropertyList] = useState([]);
    const [deletedAssignedPropertyList, setDeletedAssignedPropertyList] = useState([]);

    const headers = config.dashboard["PendingSourceTable"]?.tableLayout?.title;
    const columns = config.dashboard["PendingSourceTable"]?.tableLayout?.columns;
    const filteringTitle = config.dashboard["PendingSourceTable"]?.filterComponent?.title;
    const filteringSubTitle = config.dashboard["PendingSourceTable"]?.filterComponent?.subTitle;

    console.log({ pendingSource });
    console.log({ selectedValues });
    console.log({ view });

    const fetchData = async (numberOfRows: number, pageNo: number) => {
        const { data } = await dashboardServices.getPendingSource(
            numberOfRows,
            pageNo,
            pendingSource.options
        );
        return {
            data: data.data,
            count: data.count,
        };
    };

    useEffect(() => {
        setPreviousSelectedValues(JSON.parse(JSON.stringify(selectedValues)));
        if (views === "add") {
            setMessage("Mail Created Succesfully");
        } else if (views === "update") {
            setMessage("Mail Updated Succesfully");
        } else if (views === "back-to-list") {
            setView("list");
            updateView("list");
            return;
        } else if (views === "remove-from-list") {
            setMessage("Mail Removed Succesfully");
            setView("list");
            updateView("list");
            return;
        } else if (views === "view-more-details") {
            setView("view");
            updateView("view");
            return;
        }
        updateView(view);
    }, [
        view,
        views === "back-to-list",
        views === "remove-from-list",
        views === "view-more-details",
    ]);

    const downloadDocument = async (e: any, data: any) => {
        e.stopPropagation();
        if (data?.attachmentDetails && data.sourceType === "Mail") {
            let path = `hoaMails/${data?.attachmentDetails?.name}`;
            const documentUrl = await dashboardServices.getSignedUrl(path);

            if (documentUrl && documentUrl.data) {
                window.open(String(documentUrl.data), "_blank");
            }
        } else if (Array.isArray(data?.attachmentDetails) && data.sourceType === "Email") {
            // loop through the attachmentDetails array and download each file
            data?.attachmentDetails?.forEach(async (attachment: any) => {
                let path = `hoaEmails/${attachment}`;
                const documentUrl = await dashboardServices.getSignedUrl(path);

                if (documentUrl && documentUrl.data) {
                    window.open(String(documentUrl.data), "_blank");
                }
            });
        }
    };

    return (
        <>
            {view === "list" ? (
                <>
                    <PendingSourceFiltering
                        onAddClick={setView}
                        title={filteringTitle}
                        subTitle={filteringSubTitle}
                        tagType={"PendingSource"}
                    />
                    <PendingSourceTable
                        loading={loading}
                        headers={headers}
                        columns={columns}
                        tagType={"PendingSource"}
                        fetchData={fetchData}
                        setLoading={setLoading}
                        selectedValues={selectedValues}
                        updateSelectedValues={updateSelectedValues}
                        activeMenu={activeMenu}
                        changeActiveMenu={changeActiveMenu}
                        view={view}
                        updateView={setView}
                        downloadDocument={downloadDocument}
                    />
                </>
            ) : (
                <>
                    {previousSelectedValues &&
                    previousSelectedValues.objectId &&
                    previousSelectedValues.sourceType === "Mail" ? (
                        <>
                            <MailAssignDocument
                                previousMail={previousSelectedValues}
                                setSuccess={setSuccess}
                                view={view}
                                setView={setView}
                                tagType={"PendingSource"}
                                toggleModalOpen={toggleModalOpen}
                                selectedValues={selectedValues}
                                updateSelectedValues={updateSelectedValues}
                                assignedPropertyList={assignedPropertyList}
                                setAssignedPropertyList={setAssignedPropertyList}
                                currentAssignedProperty={currentAssignedProperty}
                                setCurrentAssignedProperty={setCurrentAssignedProperty}
                                deletedAssignedPropertyList={deletedAssignedPropertyList}
                                setDeletedAssignedPropertyList={setDeletedAssignedPropertyList}
                            />
                            <AssignPropertyModal
                                modalOpen={modalOpen}
                                toggleModalOpen={toggleModalOpen}
                                previousMail={previousSelectedValues}
                                currentAssignedProperty={currentAssignedProperty}
                                setCurrentAssignedProperty={setCurrentAssignedProperty}
                            />
                        </>
                    ) : previousSelectedValues &&
                      previousSelectedValues.objectId &&
                      previousSelectedValues.sourceType === "Email" ? (
                        <>
                            <EmailAssignDocument
                                view={view}
                                setView={setView}
                                tagType={"PendingSource"}
                                toggleModalOpen={toggleModalOpen}
                                selectedValues={selectedValues}
                                updateSelectedValues={updateSelectedValues}
                                assignedPropertyList={assignedPropertyList}
                                setAssignedPropertyList={setAssignedPropertyList}
                                currentAssignedProperty={currentAssignedProperty}
                                setCurrentAssignedProperty={setCurrentAssignedProperty}
                                deletedAssignedPropertyList={deletedAssignedPropertyList}
                                setDeletedAssignedPropertyList={setDeletedAssignedPropertyList}
                            />
                            <AssignPropertyModal
                                modalOpen={modalOpen}
                                toggleModalOpen={toggleModalOpen}
                                previousMail={previousSelectedValues}
                                currentAssignedProperty={currentAssignedProperty}
                                setCurrentAssignedProperty={setCurrentAssignedProperty}
                            />
                        </>
                    ) : null}
                </>
            )}

            <SuccessMessage success={success} setSuccess={setSuccess} message={message} />
        </>
    );
}
